export default __webpack_public_path__ + "static/media/mobile_buy.7f735f59.mp4";